/* eslint-disable no-undef */
// socket is defined by phoenix.js

const channels = {
  private: undefined,
  public: undefined
}

// const handlers = {};

const APIChannel = {
  // isConnected = false,

  connect(usePublic) {
    if (usePublic === true) {
      this.public()
    } else {
      this.private()
    }
  },

  public() {
    if (socket.isConnected() === false) {
      // console.log ("connecting", socket);
      socket.connect()
    }
    if (channels.public === undefined) {
      channels.public = socket.channel('api:public')
      channels.public
        .join()
        // .receive ("ok", resp => console.log ("joined the channel", resp))
        .receive('error', reason =>
          console.log('join failed', reason))
      // .receive("timeout", () => console.log("networking issue ..."))
    }
  },

  private() {
    // token or uuid? random number?
    this.id = window.userToken
    if (this.id == null) {
      this.id = Math.floor(Math.random() * 100)
    }
    // console.log(`token: ${this.id}`)

    if (socket.isConnected() === false) {
      // console.log ("connecting", socket)
      socket.connect()
    }
    if (channels.private == null) {
      // console.log ("channel is null", socket)
      channels.private = socket.channel(`api:${this.id}`)
      // channels.private = socket.channel (`api:public`)

      channels.private
        .join()
        // .receive("ok", resp => console.log("joined the channel", resp))
        .receive('error', reason =>
          console.log('join failed', reason))
    }
  },

  send(name, payload, callback) {
    // console.warn (`send called`, channels.private)
    if (channels.private == null || channels.private === undefined) {
      this.private()
    }

    const ref = channels.private.on(name, callback)

    // const pushEvent = channels.private
    //   .push(name, payload, 20000)
    //   .receive('ok', resp =>
    //     console.log(`${name}: ref ${ref}: message from channel`, resp))
    //   .receive('error', reason =>
    //     console.log(`${ref}: channel error`, reason))
    //   .receive('timeout', () => {
    //     console.log(`${name}: networking issue ...`, pushEvent)
    //     // channels.private.push(name, payload)
    //     // pushEvent.resend(60000)
    //   })

    channels.private.push(name, payload)

    return ref
  },

  // send(name, payload, callback) {
  //     // console.warn (`send called`, channels.private)
  //     if (channels.private == null) {
  //         this.private ()
  //     }

  //     const ref = channels.private.on (name, callback)

  //     channels.private.push (name, payload)

  //     return ref
  // },

  clear(name, ref) {
    channels.private.off(name, ref)
  },

  broadcast(name, payload, callback) {
    // console.log (`broadcasting: ${name} `, {...payload})
    if (channels.public == null) {
      this.public()
    }
    // const ref = channels.public.on (name, callback)
    channels.public.on(name, callback)
    channels.public.push(name, payload)
    // channels.public.off (name, ref)
  }
}

export default APIChannel
